import { useTheme } from '@approvalmax/theme';
import { Box, Flex, Spacing } from '@approvalmax/ui/src/components';
import range from 'lodash/range';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useMedia } from 'react-use';

export const Loading = memo(() => {
    const { theme } = useTheme();
    const isSmallScreen = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);

    return (
        <Flex justifyContent='center'>
            <Box width={isSmallScreen ? undefined : theme.container.content.small}>
                <Skeleton width={150} height={36} />

                <Spacing height={24} />

                <Flex container>
                    {range(6).map((index) => (
                        <Flex size={12} key={index}>
                            <Skeleton height={44} />
                        </Flex>
                    ))}
                </Flex>
            </Box>
        </Flex>
    );
});

Loading.displayName = 'Loading';
